import React from "react";
import { Route, Redirect } from "react-router-dom";
import useAuth from "../auth/useAuth";

const PrivateRoute = ({ component: Component, ...rest }) => {
  const auth = useAuth();

  if (!auth) return null; // ⛑️ SAFETY GUARD

  const { user, loading } = auth;

  return (
    <Route
      {...rest}
      render={(props) => {
        if (loading) return null; // or loader

        return user ? (
          <Component {...props} />
        ) : (
          <Redirect to="/sign-in" />
        );
      }}
    />
  );
};

export default PrivateRoute;
